module.exports = __webpack_public_path__ + "ca07ee68e93998054e4516daabd8560f.pdf";